import type { ReactNode } from 'react';
import ErrorIcon from '../../../../common/src/img/alert_error.svg?react';
import InfoIcon from '../../../../common/src/img/alert_info.svg?react';
import SuccessIcon from '../../../../common/src/img/alert_success.svg?react';
import WarningIcon from '../../../../common/src/img/alert_warning.svg?react';
import styles from './styles.module.scss';

interface AlertProps {
  type: string;
  children: ReactNode;
}

const Alert = (props: AlertProps) => {
  const { type = 'error', children = 'This is an error alert — check it out!' } = props;
  return (
    <div className={`${styles.alert} ${styles[type]}`}>
      <div className={styles.icon}>
        {type === 'error' && <ErrorIcon />}
        {type === 'warning' && <WarningIcon />}
        {type === 'info' && <InfoIcon />}
        {type === 'success' && <SuccessIcon />}
      </div>
      <div className={styles.message}>{children}</div>
    </div>
  );
};

export default Alert;
